import { z } from "zod";

// Zod compiles a faster parser with `new Function` where a page allows eval, and asks by trying it once,
// when the first object schema is made. The pages allow none (public/_headers), and Chrome reports the
// attempt as a policy violation although Zod catches it. Jitless parses the same without asking. main.tsx
// imports this first, before any schema is made.
z.config({ jitless: true });
